
export default {
  props: {
    showActionsButtons: Boolean,
    categoryName: String,
    categoryPath: String,
    categoryId: Number,
  },
}
